import {stormSewerStatuses} from "@/components/mixins/StormSewersMixin.js";

export const infraEquipmentHelper = {
    methods: {
        getLocationUncertaintyTypes: function () {
            return Object.entries(infraEquipmentLocationUncertainty).map(([name, value]) => ({
                name,
                value,
            }));
        },
        getInfraEquipmentStatus: function () {
            return [
                {name: this.$t('mixed_waste_bins.status_good'), value: infraEquipmentStatus.GOOD},
                {name: this.$t('mixed_waste_bins.status_defective'), value: infraEquipmentStatus.DEFECTIVE}
            ]
        },
        getStatusString: function (status) {
            switch (status) {
                case stormSewerStatuses.OK:
                    return this.$t('storm_sewers.status_ok')
                case stormSewerStatuses.DEFECT:
                    return this.$t('storm_sewers.status_defect')
                case stormSewerStatuses.REMOVED:
                    return this.$t('storm_sewers.status_removed')
            }
        },
        getInfraEquipmentMaterials: function () {
            return [
                {name: this.$t('mixed_waste_bins.material_concrete'), value: infraEquipmentMaterials.CONCRETE},
                {name: this.$t('mixed_waste_bins.material_element_mesh'), value: infraEquipmentMaterials.ELEMENT_MESH},
                {name: this.$t('mixed_waste_bins.material_double_sided_steel_beam'), value: infraEquipmentMaterials.DOUBLE_SIDED_STEEL_BEAM},
                {name: this.$t('mixed_waste_bins.material_stone'), value: infraEquipmentMaterials.STONE},
                {name: this.$t('mixed_waste_bins.material_fiberglass'), value: infraEquipmentMaterials.FIBERGLASS},
                {name: this.$t('mixed_waste_bins.material_metal'), value: infraEquipmentMaterials.METAL},
                {name: this.$t('mixed_waste_bins.material_plastic'), value: infraEquipmentMaterials.PLASTIC},
                {name: this.$t('mixed_waste_bins.material_armored_mesh'), value: infraEquipmentMaterials.ARMORED_MESH},
                {name: this.$t('mixed_waste_bins.material_tubular_beam'), value: infraEquipmentMaterials.TUBULAR_BEAM},
                {name: this.$t('mixed_waste_bins.material_wood'), value: infraEquipmentMaterials.WOOD},
                {name: this.$t('mixed_waste_bins.material_steel'), value: infraEquipmentMaterials.STEEL},
                {name: this.$t('mixed_waste_bins.material_steel_beam'), value: infraEquipmentMaterials.STEEL_BEAM},
                {name: this.$t('mixed_waste_bins.material_steel_mesh'), value: infraEquipmentMaterials.STEEL_MESH},
                {name: this.$t('mixed_waste_bins.material_cable'), value: infraEquipmentMaterials.CABLE},
                {name: this.$t('mixed_waste_bins.material_cast_iron'), value: infraEquipmentMaterials.CAST_IRON},
                {name: this.$t('mixed_waste_bins.material_other'), value: infraEquipmentMaterials.OTHER},
                {name: this.$t('mixed_waste_bins.material_unknown'), value: infraEquipmentMaterials.UNKNOWN}
            ]
        },
        getInfraEquipmentLifeCycle: function (){
            return [
                {name: this.$t('mixed_waste_bins.lifecycle_planned'), value: infraEquipmentLifecycle.PLANNED},
                {name: this.$t('mixed_waste_bins.lifecycle_under_construction'), value: infraEquipmentLifecycle.UNDER_CONSTRUCTION},
                {name: this.$t('mixed_waste_bins.lifecycle_permanently_in_use'), value: infraEquipmentLifecycle.PERMANENTLY_IN_USE},
                {name: this.$t('mixed_waste_bins.lifecycle_temporarily_in_use'), value: infraEquipmentLifecycle.TEMPORARILY_IN_USE},
                {name: this.$t('mixed_waste_bins.lifecycle_temporarily_out_of_use'), value: infraEquipmentLifecycle.TEMPORARILY_OUT_OF_USE},
                {name: this.$t('mixed_waste_bins.lifecycle_outgoing_permanent_device'), value: infraEquipmentLifecycle.OUTGOING_PERMANENT_DEVICE}

            ]
        },
        getInfraEquipmentCondition: function (){
            return [
                {name: this.$t('mixed_waste_bins.condition_very_bad'), value: infraEquipmentCondition.VERY_BAD},
                {name: this.$t('mixed_waste_bins.condition_bad'), value: infraEquipmentCondition.BAD},
                {name: this.$t('mixed_waste_bins.condition_satisfactory'), value: infraEquipmentCondition.SATISFACTORY},
                {name: this.$t('mixed_waste_bins.condition_good'), value: infraEquipmentCondition.GOOD},
                {name: this.$t('mixed_waste_bins.condition_very_good'), value: infraEquipmentCondition.VERY_GOOD},
                {name: this.$t('mixed_waste_bins.condition_unknown'), value: infraEquipmentCondition.UNKNOWN},
                {name: this.$t('mixed_waste_bins.condition_could_not_be_checked'), value: infraEquipmentCondition.COULD_NOT_BE_CHECKED}
            ]
        },
        normalizeIds: function(selected) {
            if (!selected) return []
            const ids = selected.map(item => {
                if (item === null || item === undefined) return null
                if (typeof item === 'object') return item.id
                return item // number/string id
            }).filter(id => id !== null && id !== undefined)
            // unique
            return Array.from(new Set(ids))
        }
    }
}

export const infraEquipmentMaterials = {
    CONCRETE: 1,
    ELEMENT_MESH: 2,
    DOUBLE_SIDED_STEEL_BEAM: 3,
    STONE: 4,
    FIBERGLASS: 5,
    METAL: 6,
    PLASTIC: 7,
    ARMORED_MESH: 8,
    TUBULAR_BEAM: 9,
    WOOD: 10,
    STEEL: 11,
    STEEL_BEAM: 12,
    STEEL_MESH: 13,
    CABLE: 14,
    CAST_IRON: 15,
    OTHER: 16,
    UNKNOWN: 17
}

export const infraEquipmentCreationMethod = {
    DIGITALIZATION: 1,
    CADASTRAL_PROCEDURE: 2,
    IMAGE_MEASUREMENT: 3,
    LASER_SCANNED: 4,
    FIELD_SURVEY: 5,
    SCANNED: 6,
    UNKNOWN: 7,
    OTHER: 8
}

export const infraEquipmentLocationUncertainty = {
    '0.15' : 1,
    '0.2'  : 2,
    '0.3'  : 3,
    '0.5'  : 4,
    '0.7'  : 5,
    '1'    : 6,
    '1.5'  : 7,
    '2'    : 8,
    '3'    : 9,
    '5'    : 10,
    '7.5'  : 11,
    '10'   : 12,
    '20'   : 13
}

export const infraEquipmentLifecycle = {
    PLANNED: 1,
    UNDER_CONSTRUCTION: 2,
    PERMANENTLY_IN_USE: 3,
    TEMPORARILY_IN_USE: 4,
    TEMPORARILY_OUT_OF_USE: 5,
    OUTGOING_PERMANENT_DEVICE: 6
}

export const infraEquipmentStatus = {
    GOOD: 1,
    DEFECTIVE: 2,
}

export const infraEquipmentCondition ={
    VERY_BAD: 1,
    BAD: 2,
    SATISFACTORY: 3,
    GOOD: 4,
    VERY_GOOD: 5,
    UNKNOWN: 6,
    COULD_NOT_BE_CHECKED: 7

}
